import {
  enumPageSizeValues,
  kPageSizeRadioGroup,
  kDPIScreen,
  enumPageOrientationOptions
} from "../constants";

export function MapPageSizeToString(width, height, orientation) {
  var i = 0,
    l = kPageSizeRadioGroup.length;
  if (orientation == enumPageOrientationOptions.landscape) {
    var t = width;
    width = height;
    height = t;
  }

  var dpi = kDPIScreen; // this.GetDPI();
  var done = false;
  while (!done) {
    var x = Math.floor(kPageSizeRadioGroup[i][enumPageSizeValues.pageWidth] * kDPIScreen);
    var y = Math.floor(kPageSizeRadioGroup[i][enumPageSizeValues.pageHeight] * kDPIScreen);
    if (x == width && y == height) return kPageSizeRadioGroup[i][1];
    i++;
    if (i >= l) done = true;
  }

  return "CustomPS";
}
